import React from "react";
import ProspectForm from "./components/ProspectForm";
import WalletLayout from "../components/WalletLayout";
import { useConfigureFooter } from "~hooks/useHelpers";

const Prospect = () => {
  useConfigureFooter({
    form: true,
    formId: "prospect"
  })

  return (
    <WalletLayout>
      <ProspectForm />
    </WalletLayout>
  );
};

export default Prospect;
